import { OpenApiDefinitionWidget } from '@backstage/plugin-api-docs';
import {
  configApiRef,
  identityApiRef,
  useApi,
} from '@backstage/core-plugin-api';
import { useEffect, useState } from 'react';
import { VpnWarning } from './VpnWarning.tsx';

interface BackendProxyingOpenApiDefinitionWidgetProps {
  openApiDefinition: string;
}

function BackendProxyingOpenApiDefinitionWidget(
  props: BackendProxyingOpenApiDefinitionWidgetProps,
) {
  const configApi = useApi(configApiRef);

  const identityApi = useApi(identityApiRef);
  const [token, setToken] = useState<string | undefined>(undefined);

  useEffect(() => {
    const fetchWithAuth = async () => {
      const credentials = await identityApi.getCredentials();
      const bToken = credentials?.token;
      if (bToken) {
        setToken(bToken);
      }
    };

    fetchWithAuth();
  }, [identityApi]);

  if (!token) {
    return <div>Loading Backstage backend API token...</div>;
  }

  const backstageBackendBaseUrl = configApi.getString('frontend.openApiApiProxyBackendBaseUrl')
  return (
    <OpenApiDefinitionWidget
      definition={props.openApiDefinition}
      requestInterceptor={createRequestInterceptor(
        backstageBackendBaseUrl,
        token,
      )}
    />
  );
}

function createRequestInterceptor(
  backstageBackendBaseUrl: string,
  token: string,
) {
  return (req: any) => {
    const serviceHostAndPath = req.url
      .replace('https://', '')
      .replace('http://', '');
    const rewrittenUrl = `${backstageBackendBaseUrl}/api/apiproxy/openapi-proxy/${serviceHostAndPath}`;
    req.url = rewrittenUrl;
    req.headers.Authorization = `Bearer ${token}`;
    return req;
  };
}

// Creates a React component for Backstage for overriding openapi Swagger UI.
// It routes requests through the Backstage backend proxy
// to avoid the need for CORS configuration for each service exposing OpenApi api-doc
// to be able to send requests to that service from Backstage Swagger UI
export function createBackendProxyingOpenApiDefinitionWidget(
  openApiDefinition: string,
) {
  return (
    <>
      <VpnWarning />
      <BackendProxyingOpenApiDefinitionWidget
        openApiDefinition={openApiDefinition}
      />
    </>
  );
}
